
import { defineComponent, Ref, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import wishListsStore from '../wish-lists.store';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';

export default defineComponent({
    name: 'WishListDeleteButton',
    components: { BaseDialog },
    setup() {
        const router = useRouter();
        const showDeleteList: Ref<boolean> = ref(false);
        const labels = useBlockLabels();
        const id = useRouteQuery<string>(QueryKeys.Id);

        const deleteList = async(): Promise<void> => {
            if (id.value) {
                await wishListsStore.deleteList(id.value);
                showDeleteList.value = false;
                router.go(-1);
            }
        };

        return {
            showDeleteList,
            labels,
            deleteList,
        };
    },
});
